// jQuery touch events potrebne za galeriju
import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.touchSwipe.min';
import searchFilter from '@PROJECT_ROOT/assets/desktop/js/search/privateFilter';
// replace Select options generic jQuery extension function
import '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/reservation/replaceOptions';
// presentation inline reservation
import {
    singleInit,
    reservationAfterLoad,
} from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/reservation/single';
import '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/gallery-inline';
import '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/gallery-fullscreen';
import { unitCompareToggleButton } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Compare';
import { unitFavoriteToggleButton } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Favorites';

/**
 * VAŽNO: ova skripta se trenutno uključuje na više mjesta na desktop site-u što je protiv našeg pravila o jednoj
 * *page.js skripti po stranici. Cilj je njen kôd prebaciti u druge skripte, a nju ukloniti sa site-a.
 *
 * Kôd se može prebacivati u sljedeće datoteke:
 * * assets/desktop/js/common.js za kôd koji se treba izvoditi na svakoj desktop stranici
 * * assets/desktop/js/privateShowPage.js kôd potreban samo na prezentaciji privatnog smještaja
 * * assets/desktop/js/privateSearchPage.js kôd potreban samo na rezultatima pretrage privatnog smještaja
 * * napraviti novu *page.js datoteku za stranicu za rezervaciju smještaja
 *
 * @see https://home/projects/it/wiki/Adriatichr_development_conventions#Pravila-za-javascript-module
 */

window.searchFilter = searchFilter;
window.singleInit = singleInit;
window.reservationAfterLoad = reservationAfterLoad;

$(() => {
    unitCompareToggleButton({
        onAdd: clearCachedUnits,
        onRemove: clearCachedUnits,
    });
    unitFavoriteToggleButton({
        onAdd: clearCachedUnits,
        onRemove: clearCachedUnits,
    });
});

function clearCachedUnits() {
    $('.unitsMenuBar').removeData();
}
